// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/compliance.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.GostStandard
 */
export const GostStandard = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GostStandard",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "standard_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "adoption_date", kind: "message", T: Timestamp },
    { no: 8, name: "effective_date", kind: "message", T: Timestamp },
    { no: 9, name: "withdrawal_date", kind: "message", T: Timestamp },
    { no: 10, name: "superseded_by_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "publication_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "attrs", kind: "message", T: Struct },
    { no: 15, name: "created_at", kind: "message", T: Timestamp },
    { no: 16, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.Okpd2Code
 */
export const Okpd2Code = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Okpd2Code",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "includes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "excludes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "tn_ved_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.TnVedCode
 */
export const TnVedCode = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TnVedCode",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "import_duty_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "export_duty_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "vat_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "excise_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "eeu_notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "effective_from", kind: "message", T: Timestamp },
    { no: 17, name: "effective_to", kind: "message", T: Timestamp },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CertificationType
 */
export const CertificationType = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CertificationType",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issuing_bodies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "typical_validity_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "requires_renewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "badge_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
    { no: 14, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ProductCertification
 */
export const ProductCertification = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductCertification",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "certification_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "certificate_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issuing_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "issuing_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "issue_date", kind: "message", T: Timestamp },
    { no: 9, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 10, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "gost_standard_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "attrs", kind: "message", T: Struct },
    { no: 14, name: "created_at", kind: "message", T: Timestamp },
    { no: 15, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "certification_type", kind: "message", T: CertificationType },
    { no: 21, name: "gost_standards", kind: "message", T: GostStandard, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ProductOkpd2Link
 */
export const ProductOkpd2Link = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductOkpd2Link",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
    { no: 9, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "okpd2", kind: "message", T: Okpd2Code },
  ],
);

/**
 * @generated from message omnios.v1.ProductTnVedLink
 */
export const ProductTnVedLink = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductTnVedLink",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tn_ved_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "origin_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "tn_ved", kind: "message", T: TnVedCode },
  ],
);

/**
 * @generated from message omnios.v1.ProductGostLink
 */
export const ProductGostLink = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductGostLink",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "gost_standard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "relevance_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "gost_standard", kind: "message", T: GostStandard },
  ],
);

/**
 * @generated from message omnios.v1.CertificationAlert
 */
export const CertificationAlert = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CertificationAlert",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "certification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "alert_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "days_until_expiry", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "is_acknowledged", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "acknowledged_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "acknowledged_at", kind: "message", T: Timestamp },
    { no: 9, name: "created_at", kind: "message", T: Timestamp },
    { no: 20, name: "certification", kind: "message", T: ProductCertification },
  ],
);

/**
 * @generated from message omnios.v1.CategoryOkpd2Mapping
 */
export const CategoryOkpd2Mapping = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CategoryOkpd2Mapping",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 20, name: "okpd2", kind: "message", T: Okpd2Code },
  ],
);

/**
 * Aggregate view for product compliance summary
 *
 * @generated from message omnios.v1.ProductComplianceSummary
 */
export const ProductComplianceSummary = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductComplianceSummary",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "okpd2_links", kind: "message", T: ProductOkpd2Link, repeated: true },
    { no: 3, name: "tn_ved_links", kind: "message", T: ProductTnVedLink, repeated: true },
    { no: 4, name: "gost_links", kind: "message", T: ProductGostLink, repeated: true },
    { no: 5, name: "certifications", kind: "message", T: ProductCertification, repeated: true },
    { no: 6, name: "active_certifications_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "expiring_certifications_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "expired_certifications_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * AI suggestion results
 *
 * @generated from message omnios.v1.Okpd2Suggestion
 */
export const Okpd2Suggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Okpd2Suggestion",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.TnVedSuggestion
 */
export const TnVedSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TnVedSuggestion",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "estimated_duty_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.GostSuggestion
 */
export const GostSuggestion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GostSuggestion",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "relevance_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchGostStandardsRequest
 */
export const SearchGostStandardsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchGostStandardsRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "standard_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchGostStandardsResponse
 */
export const SearchGostStandardsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchGostStandardsResponse",
  () => [
    { no: 1, name: "standards", kind: "message", T: GostStandard, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetGostStandardRequest
 */
export const GetGostStandardRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetGostStandardRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetGostSupersessionChainRequest
 */
export const GetGostSupersessionChainRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetGostSupersessionChainRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetGostSupersessionChainResponse
 */
export const GetGostSupersessionChainResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetGostSupersessionChainResponse",
  () => [
    { no: 1, name: "chain", kind: "message", T: GostStandard, repeated: true },
    { no: 2, name: "active_standard", kind: "message", T: GostStandard },
  ],
);

/**
 * @generated from message omnios.v1.SearchOkpd2Request
 */
export const SearchOkpd2Request = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchOkpd2Request",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchOkpd2Response
 */
export const SearchOkpd2Response = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchOkpd2Response",
  () => [
    { no: 1, name: "codes", kind: "message", T: Okpd2Code, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetOkpd2HierarchyRequest
 */
export const GetOkpd2HierarchyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOkpd2HierarchyRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetOkpd2HierarchyResponse
 */
export const GetOkpd2HierarchyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetOkpd2HierarchyResponse",
  () => [
    { no: 1, name: "ancestors", kind: "message", T: Okpd2Code, repeated: true },
    { no: 2, name: "children", kind: "message", T: Okpd2Code, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SearchTnVedRequest
 */
export const SearchTnVedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchTnVedRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "level", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchTnVedResponse
 */
export const SearchTnVedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchTnVedResponse",
  () => [
    { no: 1, name: "codes", kind: "message", T: TnVedCode, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetTnVedHierarchyRequest
 */
export const GetTnVedHierarchyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTnVedHierarchyRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetTnVedHierarchyResponse
 */
export const GetTnVedHierarchyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTnVedHierarchyResponse",
  () => [
    { no: 1, name: "ancestors", kind: "message", T: TnVedCode, repeated: true },
    { no: 2, name: "children", kind: "message", T: TnVedCode, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListCertificationTypesRequest
 */
export const ListCertificationTypesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCertificationTypesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListCertificationTypesResponse
 */
export const ListCertificationTypesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCertificationTypesResponse",
  () => [
    { no: 1, name: "types", kind: "message", T: CertificationType, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateCertificationTypeRequest
 */
export const CreateCertificationTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateCertificationTypeRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "issuing_bodies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "typical_validity_months", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "requires_renewal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "badge_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateCertificationTypeRequest
 */
export const UpdateCertificationTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateCertificationTypeRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "issuing_bodies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "typical_validity_months", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "requires_renewal", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "badge_color", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteCertificationTypeRequest
 */
export const DeleteCertificationTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteCertificationTypeRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateProductCertificationRequest
 */
export const CreateProductCertificationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateProductCertificationRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "certification_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "certificate_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "issuing_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "issuing_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "issue_date", kind: "message", T: Timestamp },
    { no: 7, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "gost_standard_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdateProductCertificationRequest
 */
export const UpdateProductCertificationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateProductCertificationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "certificate_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "issuing_body", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "issuing_country", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "issue_date", kind: "message", T: Timestamp },
    { no: 6, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "gost_standard_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeleteProductCertificationRequest
 */
export const DeleteProductCertificationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteProductCertificationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductCertificationsRequest
 */
export const ListProductCertificationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductCertificationsRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListProductCertificationsResponse
 */
export const ListProductCertificationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListProductCertificationsResponse",
  () => [
    { no: 1, name: "certifications", kind: "message", T: ProductCertification, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetProductOkpd2Request
 */
export const SetProductOkpd2Request = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductOkpd2Request",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "links", kind: "message", T: ProductOkpd2LinkInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ProductOkpd2LinkInput
 */
export const ProductOkpd2LinkInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductOkpd2LinkInput",
  () => [
    { no: 1, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetProductOkpd2Response
 */
export const SetProductOkpd2Response = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductOkpd2Response",
  () => [
    { no: 1, name: "links", kind: "message", T: ProductOkpd2Link, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetProductTnVedRequest
 */
export const SetProductTnVedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductTnVedRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "links", kind: "message", T: ProductTnVedLinkInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ProductTnVedLinkInput
 */
export const ProductTnVedLinkInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductTnVedLinkInput",
  () => [
    { no: 1, name: "tn_ved_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_primary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "origin_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetProductTnVedResponse
 */
export const SetProductTnVedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductTnVedResponse",
  () => [
    { no: 1, name: "links", kind: "message", T: ProductTnVedLink, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetProductGostRequest
 */
export const SetProductGostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductGostRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "links", kind: "message", T: ProductGostLinkInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ProductGostLinkInput
 */
export const ProductGostLinkInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductGostLinkInput",
  () => [
    { no: 1, name: "gost_standard_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "relevance_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetProductGostResponse
 */
export const SetProductGostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetProductGostResponse",
  () => [
    { no: 1, name: "links", kind: "message", T: ProductGostLink, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetProductComplianceRequest
 */
export const GetProductComplianceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductComplianceRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetProductComplianceResponse
 */
export const GetProductComplianceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetProductComplianceResponse",
  () => [
    { no: 1, name: "summary", kind: "message", T: ProductComplianceSummary },
  ],
);

/**
 * @generated from message omnios.v1.ListCertificationAlertsRequest
 */
export const ListCertificationAlertsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCertificationAlertsRequest",
  () => [
    { no: 1, name: "include_acknowledged", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListCertificationAlertsResponse
 */
export const ListCertificationAlertsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCertificationAlertsResponse",
  () => [
    { no: 1, name: "alerts", kind: "message", T: CertificationAlert, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AcknowledgeAlertRequest
 */
export const AcknowledgeAlertRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcknowledgeAlertRequest",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AcknowledgeAlertResponse
 */
export const AcknowledgeAlertResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AcknowledgeAlertResponse",
  () => [
    { no: 1, name: "alert", kind: "message", T: CertificationAlert },
  ],
);

/**
 * @generated from message omnios.v1.SuggestOkpd2Request
 */
export const SuggestOkpd2Request = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestOkpd2Request",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "category_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestOkpd2Response
 */
export const SuggestOkpd2Response = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestOkpd2Response",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: Okpd2Suggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SuggestTnVedRequest
 */
export const SuggestTnVedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestTnVedRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestTnVedResponse
 */
export const SuggestTnVedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestTnVedResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: TnVedSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SuggestGostRequest
 */
export const SuggestGostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestGostRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SuggestGostResponse
 */
export const SuggestGostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestGostResponse",
  () => [
    { no: 1, name: "suggestions", kind: "message", T: GostSuggestion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportGostStandardsRequest
 */
export const BulkImportGostStandardsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportGostStandardsRequest",
  () => [
    { no: 1, name: "standards", kind: "message", T: GostStandardInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GostStandardInput
 */
export const GostStandardInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GostStandardInput",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "standard_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "adoption_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "effective_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "withdrawal_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "superseded_by_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "publication_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportGostStandardsResponse
 */
export const BulkImportGostStandardsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportGostStandardsResponse",
  () => [
    { no: 1, name: "imported", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportOkpd2Request
 */
export const BulkImportOkpd2Request = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportOkpd2Request",
  () => [
    { no: 1, name: "codes", kind: "message", T: Okpd2Input, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.Okpd2Input
 */
export const Okpd2Input = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Okpd2Input",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "includes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "excludes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "tn_ved_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportOkpd2Response
 */
export const BulkImportOkpd2Response = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportOkpd2Response",
  () => [
    { no: 1, name: "imported", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportTnVedRequest
 */
export const BulkImportTnVedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportTnVedRequest",
  () => [
    { no: 1, name: "codes", kind: "message", T: TnVedInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.TnVedInput
 */
export const TnVedInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TnVedInput",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "import_duty_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "export_duty_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "vat_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "excise_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "eeu_notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "effective_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "effective_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkImportTnVedResponse
 */
export const BulkImportTnVedResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkImportTnVedResponse",
  () => [
    { no: 1, name: "imported", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "updated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "error_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SetCategoryOkpd2MappingRequest
 */
export const SetCategoryOkpd2MappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCategoryOkpd2MappingRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mappings", kind: "message", T: CategoryOkpd2MappingInput, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CategoryOkpd2MappingInput
 */
export const CategoryOkpd2MappingInput = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CategoryOkpd2MappingInput",
  () => [
    { no: 1, name: "okpd2_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.SetCategoryOkpd2MappingResponse
 */
export const SetCategoryOkpd2MappingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetCategoryOkpd2MappingResponse",
  () => [
    { no: 1, name: "mappings", kind: "message", T: CategoryOkpd2Mapping, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetCategoryOkpd2MappingRequest
 */
export const GetCategoryOkpd2MappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCategoryOkpd2MappingRequest",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCategoryOkpd2MappingResponse
 */
export const GetCategoryOkpd2MappingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCategoryOkpd2MappingResponse",
  () => [
    { no: 1, name: "mappings", kind: "message", T: CategoryOkpd2Mapping, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetExpiringCertificationsRequest
 */
export const GetExpiringCertificationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetExpiringCertificationsRequest",
  () => [
    { no: 1, name: "days_ahead", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetExpiringCertificationsResponse
 */
export const GetExpiringCertificationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetExpiringCertificationsResponse",
  () => [
    { no: 1, name: "certifications", kind: "message", T: ExpiringCertificationSummary, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ExpiringCertificationSummary
 */
export const ExpiringCertificationSummary = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExpiringCertificationSummary",
  () => [
    { no: 1, name: "certification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "certification_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "certificate_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 7, name: "days_until_expiry", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.InitDefaultCertificationTypesRequest
 */
export const InitDefaultCertificationTypesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InitDefaultCertificationTypesRequest",
  [],
);

/**
 * @generated from message omnios.v1.InitDefaultCertificationTypesResponse
 */
export const InitDefaultCertificationTypesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InitDefaultCertificationTypesResponse",
  () => [
    { no: 1, name: "created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

